// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"480c7466","455":"63fe36dd","977":"18d6d345"}[chunkId] + ".chunk.js";
};